import { useLayoutEffect } from 'react';

import { applyEmbedChrome } from './embedChrome';

/**
 * Hides the ApplicationWrapper header and ensures the chat fills the full iframe
 * height when Bernoulli is loaded via the /embed route.
 */
function EmbedHeaderHider() {
  useLayoutEffect(() => applyEmbedChrome(), []);

  return null;
}

export default EmbedHeaderHider;
